import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import IconButton from 'modules/legal_entities/pages/settings/ContractsLegalEntityPage/_PayrollFields/_PayrollFieldList/_Modal/_IconButton'
import ModalOptionInput from 'modules/legal_entities/pages/settings/ContractsLegalEntityPage/_PayrollFields/_PayrollFieldList/_Modal/_ModalOptionInput'

import type { EditableOption } from './types'

type Props = {
  options?: EditableOption[]
  onAddOption: () => void
  handleInputChange: (index: number, value: string) => void
  onArchiveOption: (index: number) => void
  onDeleteOption: (index: number) => void
}

const ModalOptions = ({
  options,
  onAddOption,
  handleInputChange,
  onArchiveOption,
  onDeleteOption,
}: Props) => {
  return (
    <Box flexDirection="column" gap="s16">
      <Text.Normal size="200" color="grey1000" weight="medium">
        {i18n.t('settings.legal_entities.legal_entity.contracts.modal.options.description')}
      </Text.Normal>
      <Box gap="s8">
        {options?.map((option, index) => (
          <Box key={index} flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <ModalOptionInput
              label={option.label}
              onChange={(value) => handleInputChange(index, value)}
              archived={!!option.archivedAt}
              draft={!!option.new}
            />
            <Box paddingLeft="s8">
              <IconButton
                archived={!!option.archivedAt}
                draft={!!option.new}
                archiveHandler={() => onArchiveOption(index)}
                deleteHandler={() => onDeleteOption(index)}
              />
            </Box>
          </Box>
        ))}
      </Box>
      <Button type="secondary" onClick={onAddOption} iconName="add">
        {i18n.t('settings.legal_entities.legal_entity.contracts.modal.add_resource')}
      </Button>
    </Box>
  )
}

export default ModalOptions
